import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],

});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllPresenceStagiaire({ commit }, params = {}) {
        const { page = 0, size = 10, sort = ''} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
        }).toString();
        let data = await client.get('presences/stagiaire');
        return data;
    },
    async getAllPresenceMaitre({ commit }, params = {}) {
        const { page = 0, size = 10, sort = ''} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
        }).toString();
        let data = await client.get('presences/maitre');
        return data;
    },
    async getAll(cxt) {
        let data = await client.get('presences/all');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) {
        let data = await client.get('presences/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('presences/update/' + payload.id, payload) : await client.post('presences/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async getStatistiques(cxt, stagiaireId) {
        let data = await client.get('presences/stats/stagiaire/' + stagiaireId);
        return data;
    },
   
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
